module.exports = __webpack_public_path__ + "static/media/no-asset.cbdb2614.webp";